import { SuggestedInsuranceLight } from '../../lib/types/models/insurance/insurance'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type SuggestedInsurancesInput = {
  cseCode?: string | null
  residenceCountry: string
  destinationCountryId: number
}

export function getSuggestedInsurances(input: SuggestedInsurancesInput) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.insurances.suggestions.url, null), input))
    .get<SuggestedInsuranceLight[]>()
}
